import { ExitToApp as SignOutIcon } from "@mui/icons-material";
import { Button, CssBaseline } from "@mui/material";
import logo from "../../assets/reap-logo-notext.svg";
import { signOut } from "../../libs/auth";
import { appStrings as strings } from "../../resources/strings/app";
import { Permissions } from "../../types";
import { MenuComponent } from "./MenuComponent";
import { menuItems } from "./listItems";

interface Props {
  children: JSX.Element;
  user: object | null;
  permissions: Permissions | null;
}
type Component = (props: Props) => JSX.Element;

export const Layout: Component = ({ children, user, permissions }) => {
  const LoggedInLayout = () => {
    const handleSignOut = () => signOut();
    const additionalContent = (
      <Button color="inherit" onClick={handleSignOut}>
        {strings.labels.signOut}
        <SignOutIcon sx={(theme) => ({ marginX: theme.spacing(1) })} />
      </Button>
    );

    return (
      <MenuComponent
        menuItems={menuItems}
        permissions={permissions}
        logo={logo}
        additionalContent={additionalContent}
      >
        {children}
      </MenuComponent>
    );
  };
  const LoggedOutLayout = () => <>{children}</>;

  return (
    <>
      <CssBaseline />
      {user ? <LoggedInLayout /> : <LoggedOutLayout />}
    </>
  );
};
